module.exports = __webpack_public_path__ + "img/mechanicsToolbox.d8286fc5.png";